module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f27bd3fc11913ac19cf04b4652c61315.png";